<bb-file-attachment-ui
  [name]="attachment.name"
  [size]="attachment.size"
  [fileContent]="attachment.fileContent"
></bb-file-attachment-ui>
